module.exports = __webpack_public_path__ + "img/global-variables.4d40f6db.svg";